<template>
    <div class="news-work">
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/list/examGuidance' }">考试指导</el-breadcrumb-item>
            <el-breadcrumb-item>视频指导</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-wrapper main examGuidance_box">
            <div class="examGuidance">
                <div class="video" id="mse"></div>
                <div class="video-sidebar flex-column">
                    <div class="group time">
                        <h3>课节时间</h3>
                        <p>{{lessonInfo}}</p>
                    </div>
                    <div class="group introduction">
                        <h3>课程介绍</h3>
                        <p>{{courseInfo}}</p>
                        <!-- <p v-html="(courseInfo && courseInfo.courseExplain) || '暂无简介'"></p> -->
                    </div>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>
 
<script>
import Player from 'xgplayer'
import HlsJsPlyaer from 'xgplayer-hls.js';
export default {
    data() {
        return {
            videoPlayer: null,//播放器
            videoType: false,//视频类型
            videoSrc: '',//视频地址
            playStamp: '',//播放标识
            currentTime: null, //当前播放时间
            isReplay: false, // 是否重播
            totalStamp: null, //可拖拽的最大进度
            interval: undefined, //非m3u8视频计时定时器
            lessonInfo: '', //课节信息
            courseInfo: '', //课节所在在课程信息
        }
    },
    watch: {
        '$route': function (to, from) {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.showBtn = true;
        }
    },
    methods: {
        initPlayerBym3u8() {
            console.log('this.videoSrc', this.videoSrc);
            this.videoPlayer = new HlsJsPlyaer({
                width: '100%',
                height: '100%',
                el: document.querySelector('#mse'),
                url: this.videoSrc,
                // url: '//lf3-static.bytednsdoc.com/obj/eden-cn/nupenuvpxnuvo/xgplayer_doc/xgplayer-demo.mp4',
                error: "视频异常",
                volume: 0.6, //初始音量
                autoplay: true, //自动播放
                cors: true, //请求是否跨域
                lang: 'zh-cn',
            });
            // 注册播放事件
            this.videoPlayer.on("play", () => {
                if (this.isReplay) {
                    // 重播,不设置记忆时间但依旧计时
                    this.videoPlayer.currentTime = 0;
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                } else {
                    this.getWatchStamp();
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                }
            })
            // 注册暂停事件
            this.videoPlayer.on("pause", () => {
                console.log('暂停---', this.videoPlayer.currentTime)
                // this.currentTime = this.videoPlayer.currentTime;
                clearInterval(this.interval);
                this.putCountTime()
            })
            // 注册重播事件
            this.videoPlayer.on("replayBtnClick", () => {
                this.isReplay = true
            })
            // 注册seeking事件
            this.videoPlayer.on("seeking", () => {
                if (this.videoPlayer.currentTime > this.totalStamp) {
                    console.log('拖拽时间不能大于已播过的最大时间');
                    this.videoPlayer.currentTime = this.totalStamp
                }
            })
        },
        initPlayerBymp4() {
            this.videoPlayer = new Player({
                width: '100%',
                height: '100%',
                id: 'mse',
                url: this.videoSrc,
                error: "视频异常",
                volume: 0.6, //初始音量
                autoplay: false, //自动播放
                cors: true, //请求是否跨域
                lang: 'zh-cn',
            });
            // 注册播放事件
            this.videoPlayer.on("play", () => {
                if (this.isReplay) {
                    // 重播,不设置记忆时间但依旧计时
                    this.videoPlayer.currentTime = 0;
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                } else {
                    this.getWatchStamp();
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                }
            })
            // 注册暂停事件
            this.videoPlayer.on("pause", () => {
                console.log('暂停---', this.videoPlayer.currentTime)
                // this.currentTime = this.videoPlayer.currentTime;
                clearInterval(this.interval);
                this.putCountTime()
            })
            // 注册重播事件
            this.videoPlayer.on("replayBtnClick", () => {
                this.isReplay = true
            })
            // 注册seeking事件
            this.videoPlayer.on("seeking", () => {
                if (this.videoPlayer.currentTime > this.totalStamp) {
                    console.log('拖拽时间不能大于已播过的最大时间');
                    this.videoPlayer.currentTime = this.totalStamp
                }
            })
        },
        async getExamGuide() {
            let resData = await Api.examGuidance.getExamGuide(this.$route.query.Id);
            this.videoSrc = resData.videoPathUrl;
            this.lessonInfo = resData.createTime;
            this.courseInfo = resData.introduce;
            if (this.guessVideoFormatFromString(resData.videoPath) == 'mp4') {
                this.initPlayerBymp4();
                
            } else if (this.guessVideoFormatFromString(resData.videoPath) == 'm3u8'){
                this.initPlayerBym3u8();
            }else{
                alert('不支持视频格式播放')
            }
          
        },
        guessVideoFormatFromString(videoString) {
            // console.log('videoString',videoString);
            // 定义常见的视频文件扩展名
            const videoExtensions = ['.mp4', '.avi', '.wmv', '.mov', '.flv', '.mkv', '.webm', '.mpg', '.mpeg'];

            // 遍历扩展名列表，检查字符串是否以这些扩展名结尾
            for (const extension of videoExtensions) {
                if (videoString.toLowerCase().endsWith(extension)) {
                    // 返回匹配到的视频格式
                    return extension.slice(1); // 移除点号，只返回格式名称
                }
            }

            // 如果没有匹配到任何已知的视频格式，则返回null或其他默认值
            return null;
        }
    },
    mounted() {
        this.getExamGuide();
    },
    destroyed() {
    }
}
</script>
 
<style lang="less" scoped>
@import "./less/news_common.less";
@import "./less/news_headlines.less";

* {
    box-sizing: border-box;
}

.examGuidance_box {
    width: 100%;
    background-color: #000;

    .examGuidance {
        min-width: 1200px;
        height: 800px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .video-sidebar {
        padding: 0 20px;
        width: 20%;
        background-color: #282933;
        flex-shrink: 0;
        height: 100%;

        .group {
            margin-top: 20px;

            &:first-child {
                margin-top: 15px;
            }

            p {
                color: #fff;
                padding: 0 15px;
                line-height: 30px;
            }
        }

        h3 {
            line-height: 36px;
            color: #fff;
            font-size: 16px;
            font-weight: 500;

            &::before {
                content: ' ';
                display: inline-block;
                border-radius: 25%;
                width: 4px;
                height: 20px;
                background-color: #218AB8;
                margin-right: 10px;
                margin-bottom: -5px;
            }
        }

        .time p {
            font-size: 14px;
            margin: 5px 0 20px;
        }
    }
}
</style>